// Swipe-down-to-close progressive enhancement for the BB filter bottom-sheet.
// Attaches to .bb-filters__drawer-handle inside the filters-drawer dialog.
// Works alongside Horizon's native dialog-component — does not replace any
// of its behavior. If this script fails, dialog still closes via × / backdrop / Esc.

const SWIPE_CLOSE_THRESHOLD_RATIO = 0.3; // fraction of sheet height
const SWIPE_CLOSE_VELOCITY = 0.5;        // px/ms threshold when distance short

function attachBottomSheet(dialogEl) {
  const handle = dialogEl.querySelector('.bb-filters__drawer-handle');
  if (!handle) return;
  if (handle.dataset.bbBottomSheetBound === 'true') return;
  handle.dataset.bbBottomSheetBound = 'true';

  // The native dialog restores the old scroll position on close. After a filter
  // change that position can be below the new results (especially an empty grid).
  const component = dialogEl.closest('dialog-component');
  let resultsChanged = false;
  component?.addEventListener('dialog:open', () => { resultsChanged = false; });
  component?.addEventListener('filter:update', () => { resultsChanged = true; });
  component?.addEventListener('dialog:close', () => {
    if (!resultsChanged) return;
    resultsChanged = false;
    const results = document.getElementById('ResultsList') || document.querySelector('.bb-collection-empty');
    if (!results) return;
    results.setAttribute('tabindex', '-1');
    results.focus({ preventScroll: true });
    const toolbar = document.querySelector('.bb-filters__toolbar');
    const toolbarHeight = toolbar?.getBoundingClientRect().height || 0;
    const toolbarTop = toolbar ? parseFloat(getComputedStyle(toolbar).top) || 0 : 0;
    const top = results.getBoundingClientRect().top + window.scrollY - toolbarHeight - toolbarTop - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
  });

  let startY = null;
  let startTime = 0;
  let currentY = 0;
  let sheetHeight = 0;
  let dragging = false;

  handle.style.cursor = 'grab';
  handle.style.touchAction = 'none';

  handle.addEventListener('pointerdown', (e) => {
    startY = e.clientY;
    startTime = performance.now();
    currentY = 0;
    sheetHeight = dialogEl.getBoundingClientRect().height;
    dragging = true;
    handle.setPointerCapture(e.pointerId);
    handle.style.cursor = 'grabbing';
    dialogEl.style.transition = 'none';
  });

  handle.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    currentY = Math.max(0, e.clientY - startY);
    dialogEl.style.transform = `translateY(${currentY}px)`;
  });

  const finishDrag = (e) => {
    if (!dragging) return;
    dragging = false;
    handle.releasePointerCapture(e.pointerId);
    handle.style.cursor = 'grab';
    dialogEl.style.transition = '';

    const elapsed = performance.now() - startTime;
    const velocity = currentY / elapsed;
    const ratio = currentY / sheetHeight;

    if (ratio > SWIPE_CLOSE_THRESHOLD_RATIO || velocity > SWIPE_CLOSE_VELOCITY) {
      const dc = dialogEl.closest('dialog-component');
      if (dc && typeof dc.closeDialog === 'function') {
        dialogEl.style.transform = '';
        dc.closeDialog();
      }
    } else {
      dialogEl.style.transform = '';
    }
  };

  handle.addEventListener('pointerup', finishDrag);
  handle.addEventListener('pointercancel', finishDrag);
}

function initBottomSheets() {
  document.querySelectorAll('#filters-drawer dialog.bb-filters__drawer').forEach((dialog) => {
    attachBottomSheet(dialog);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBottomSheets, { once: true });
} else {
  initBottomSheets();
}

document.addEventListener('shopify:section:load', initBottomSheets);
document.addEventListener('filter:update', () => requestAnimationFrame(initBottomSheets));
